import { getToken } from "../utils/authUtils";
import { parseJSON } from "./parseJSON";

const urlBase = `${process.env.API_URL}/profile`;
const readUrl = (url = "") => `${urlBase}/${url}`;

export const patchProfile = async ({ telefono, oldPassword, newPassword }) => {
  const auth = `Bearer ${getToken()}`;

  let res = await fetch(readUrl(``), {
    method: "PATCH",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      telefono5: telefono,
      oldPassword,
      newPassword,
    }),
  });

  res = await parseJSON(res);

  return res.success;
};
